import { render, staticRenderFns } from "./SettingsOrder.vue?vue&type=template&id=27136472&"
import script from "./SettingsOrder.vue?vue&type=script&lang=js&"
export * from "./SettingsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports